<template>
    <div class="content">
        <div class="content_wrap">
            <h2 class="content_title">보충학습</h2>
            
            <div class="slide_wrap">
                <div class="summary_head clearfix">
                    <!-- <h2><img :src="'../assets/images/summarytitle.png'" alt="Summary"></h2> -->
                    <div class="summary_title supplementary float_left">
                        <img :src="'../assets/images/summarytitle.png'" alt="Summary">
                    </div>
                </div>
                <div class="bxslider" >
                    <!-- 반복되는 slide 시작 -->
                    <div class="slide_cont supplementary"
                        v-for="item in body"
                        v-html="item"
                    ></div>
                    <!-- 반복되는 slide 끝-->
                </div>
            </div>
        </div>
        <div class="btnwrap">
            <button @click="goNext" type="button" class="submitbt main">다음</button>
        </div>
    </div>
</template>
<script>
export default {
    props : ['result','contents'],
    data(){
        return{
            list : []
        }
    },
    computed : {
        score(){
            let count = 0;
            _.map(this.result,(value)=>{
                if(value == 'correct') count++;
            });
            return Math.round((count / this.result.length) * 100);
        },
        body(){
            if(this.score > 90){
                return this.contents.currentSlide.supplementary.bodies[0]['slides']
            }
            return this.contents.currentSlide.supplementary.bodies[1]['slides']
        }
    },
    methods:{
        goNext(){
            this.$emit('goNext');
        }
    },
    mounted(){
        $('.bxslider').bxSlider({
            mode: 'fade',
            captions: true,
            touchEnabled:true,
            preventDefaultSwipeY: false,
        });
    }
}
</script>